/**
 * `testimonials` — dealer quotes (module 22 D3).
 *
 * Auto-fit grid: cards reflow from a row to a single column as space shrinks,
 * no media query needed. Plain text (spec 42 R8).
 */
export function Testimonials({
  heading,
  items,
}: {
  heading?: string | undefined;
  items: Array<{ quote: string; author: string }>;
}) {
  return (
    <section aria-label={heading ?? "What buyers say"}>
      {heading ? (
        <h2
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 500,
            fontSize: "1.5rem",
            color: "var(--ink)",
            textAlign: "center",
            marginTop: 0,
            marginBottom: "1.5rem",
          }}
        >
          {heading}
        </h2>
      ) : null}
      <div
        style={{
          display: "grid",
          gap: "1rem",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
        }}
      >
        {items.map((t, i) => (
          <figure
            key={i}
            style={{
              margin: 0,
              padding: "1.25rem",
              border: "1px solid var(--line)",
              borderRadius: "var(--r)",
              backgroundColor: "var(--paper)",
            }}
          >
            <blockquote
              style={{ margin: 0, fontSize: "0.9375rem", lineHeight: 1.55, color: "var(--ink-2)" }}
            >
              “{t.quote}”
            </blockquote>
            <figcaption
              style={{
                marginTop: "0.75rem",
                fontWeight: 600,
                fontSize: "0.8125rem",
                color: "var(--ink)",
              }}
            >
              — {t.author}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
